export function findEnCallPage<T extends { language: string }>(
  pages: T[] | null | undefined,
): T | undefined {
  return pages?.find((p) => p.language === "en");
}
